export const CHECKBOX_KEYS = {
  STATUS: 'status',
  LOCATION_TYPE: 'locationType',
  LEGAL_FORM: 'legalForm',
}

export const RESULT_KEY_INFO = {
  TAX_CODE: 'taxCode',
  PHONE: 'telephone',
  REGISTERED_ADDRESS: 'address',
  INDUSTRY: 'vsicName',
}

export const LIST_LOCATION_TYPE = {
  HEADQUARTERS: 1,
  OTHERS: 0,
}

export const LOCATION_COLOR = {
  [LIST_LOCATION_TYPE.HEADQUARTERS]: '#E0E0E0',
}
